(() => {
  const script = document.getElementById('sh-email-events-provider');
  if (!script || script.dataset.providerBound === 'true') return;
  script.dataset.providerBound = 'true';
  const sdkUrl = 'https://static.klaviyo.com/onsite/js/UadrVg/klaviyo.js';
  const localeAliases = new Map([['es', 'es'], ['fr', 'fr'], ['de', 'de'], ['it', 'it'], ['nb', 'nb'], ['no', 'nb'], ['nl', 'nl'], ['pt', 'pt-PT'], ['pt-pt', 'pt-PT']]);
  const locale = () => {
    const value = window.Shopify?.locale || document.documentElement.lang || '';
    return typeof value === 'string' ? localeAliases.get(value.trim().replace(/_/g, '-').toLowerCase()) || null : null;
  };
  let connected = null, timer = null, deadline = 0, epoch = 0, manualObject = null;
  let sdkLoaded = false;
  let inserted = false, reloading = false, stopped = false, featurePending = false, featureRequested = false, featureFailed = false;
  let identityPending = false, identityFailed = false;
  const waits = new Set();
  const authenticated = document.getElementById('sh-email-authenticated-customer');
  const authenticatedMembers = new Set();
  const optOut = (disabled) => { document.cookie = '__kla_off=' + String(disabled) + ';path=/;SameSite=Lax'; };
  optOut(true);
  const privacyMessage = (error) => {
    let message = 'Privacy API error (message unavailable)';
    try {
      const detail = Array.isArray(error) ? error[0] : error;
      if (typeof detail === 'string') message = detail;
      else if (typeof detail?.message === 'string') message = detail.message;
      else if (typeof detail?.error?.message === 'string') message = detail.error.message;
    } catch { /* Never stringify an error object or expose its stack. */ }
    return message;
  };
  const privacyError = (kind, error) => {
    const array = Array.isArray(error);
    script.dataset.privacyErrorKind = array ? 'array' : typeof error;
    if (array) script.dataset.privacyErrorCount = String(error.length);
    script.dataset.privacyState = kind;
    script.dataset.privacyError = privacyMessage(error)
      .replace(/(?:[a-z][a-z\d+.-]*:\/\/|www\.)[^\s"'<>]+/gi, '[url]')
      .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]')
      .replace(/[?&#][^\s"'<>]*/g, '[parameters]')
      .replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
  };
  const permission = () => {
    script.dataset.methodsAvailable = 'unknown';
    script.dataset.analyticsAllowed = 'unknown';
    script.dataset.marketingAllowed = 'unknown';
    try {
      if (window.Shopify?.designMode === true || !locale()) return 'blocked';
      const privacy = window.Shopify?.customerPrivacy;
      const methods = typeof privacy?.analyticsProcessingAllowed === 'function' && typeof privacy?.marketingAllowed === 'function';
      script.dataset.methodsAvailable = String(methods);
      if (!methods) {
        if (!featurePending && !featureFailed) script.dataset.privacyState = 'methods-unavailable';
        return 'unavailable';
      }
      const analytics = privacy.analyticsProcessingAllowed();
      script.dataset.analyticsAllowed = analytics === true ? 'true' : analytics === false ? 'false' : 'unknown';
      const marketing = privacy.marketingAllowed();
      script.dataset.marketingAllowed = marketing === true ? 'true' : marketing === false ? 'false' : 'unknown';
      if (featureFailed) return 'unavailable';
      script.dataset.privacyState = 'loaded';
      return analytics === true && marketing === true ? 'allowed' : 'blocked';
    } catch (error) { featureFailed = true; privacyError('error-read', error); return 'unavailable'; }
  };
  const permitted = (visible = true) => !stopped && !reloading && permission() === 'allowed' && (!visible || !document.hidden);
  const authenticatedIdentity = (adapter) => {
    if (!authenticated) return 'none';
    if (!authenticated.textContent.trim()) return authenticatedMembers.size ? 'seen' : 'unavailable';
    try {
      const member = JSON.parse(authenticated.textContent);
      if (!/^[1-9]\d*$/.test(String(member?.id)) || typeof member?.email !== 'string' || !/^[^\s@]+@[^\s@]+$/.test(member.email)) {
        authenticated.textContent = ''; return 'unavailable';
      }
      const id = String(member.id);
      if (authenticatedMembers.has(id)) { authenticated.textContent = ''; return 'seen'; }
      const identify = adapter?.identifyAuthenticatedCustomer;
      if (typeof identify !== 'function' || !permitted()) return 'unavailable';
      window.SportsHubEmailContext?.useIdentity('customer:' + id);
      const queued = identify.call(adapter, member.email);
      authenticated.textContent = '';
      if (queued !== true) return 'unavailable';
      authenticatedMembers.add(id);
      return 'queued';
    } catch { authenticated.textContent = ''; return 'unavailable'; }
  };
  const invalidate = () => {
    epoch++;
    if (identityPending) identityFailed = true;
    identityPending = false;
    for (const view of pageViews) view.pending = false;
    for (const cancel of [...waits]) cancel();
  };
  const wait = (result, generation) => new Promise((resolve, reject) => {
    let finished = false;
    const finish = (error, value) => {
      if (finished) return;
      finished = true; clearTimeout(timeout); waits.delete(cancel);
      if (error || generation !== epoch || !permitted(false)) reject(new Error('Tracking unavailable'));
      else resolve(value);
    };
    const cancel = () => finish(true);
    const timeout = setTimeout(cancel, 5000);
    waits.add(cancel);
    if (typeof result?.then !== 'function') cancel();
    else Promise.resolve(result).then((value) => finish(false, value), cancel);
  });
  const product = (() => {
    try {
      const raw = JSON.parse(document.getElementById('sh-email-viewed-product')?.textContent || 'null');
      if (!raw || !/^[1-9]\d*$/.test(String(raw.ProductID)) || typeof raw.ProductName !== 'string') return null;
      const item = {};
      for (const key of ['Handle', 'ProductName', 'ProductID', 'SKU', 'Categories', 'ImageURL', 'URL', 'Brand', 'Price', 'CompareAtPrice', 'Currency', 'VariantID', 'VariantTitle', 'PriceMinor']) {
        if (Object.hasOwn(raw, key)) item[key] = raw[key];
      }
      return item;
    } catch { return null; }
  })();
  const pageActivity = (() => {
    try {
      const raw = JSON.parse(document.getElementById('sh-email-page-activity')?.textContent || 'null');
      if (!raw || !['collection', 'search'].includes(raw.type) || !document.querySelector(`main[data-template="${raw.type}"]`)) return null;
      const pattern = raw.type === 'collection' ? /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?collections\/[a-z0-9-]+\/?$/ : /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?search\/?$/;
      const current = new URL(window.location.href);
      const canonical = new URL(raw.URL);
      if (!pattern.test(current.pathname) || !pattern.test(canonical.pathname) || canonical.protocol !== 'https:' || canonical.username || canonical.password) return null;
      const canonicalUrl = canonical.origin + canonical.pathname;
      if (raw.type === 'collection') {
        if (!/^[1-9]\d*$/.test(String(raw.CollectionID)) || typeof raw.CollectionName !== 'string' || !raw.CollectionName.trim() || raw.CollectionName.length > 200 || /[@<>\u0000-\u001f\u007f]/.test(raw.CollectionName)) return null;
        return { name: 'SH Collection Viewed', template: 'collection', properties: { CollectionID: String(raw.CollectionID), CollectionName: raw.CollectionName, URL: canonicalUrl } };
      }
      if (raw.performed !== true || typeof raw.SearchQuery !== 'string' || !Number.isSafeInteger(raw.ResultsCount) || raw.ResultsCount < 0) return null;
      const query = raw.SearchQuery;
      // Reject recognizable sensitive patterns before truncation; no raw query enters event properties or diagnostics.
      if (/[@<>\u0000-\u001f\u007f]|(?:[a-z][a-z\d+.-]*:\/\/|www\.|\b(?:[a-z\d-]+\.)+[a-z]{2,}\b)/i.test(query) ||
          [...query.matchAll(/\+?\d[\d\s().-]{5,}\d/g)].some(([match]) => match.replace(/\D/g, '').length >= 7)) return null;
      const safe = query.replace(/\s+/g, ' ').trim().slice(0, 120);
      return safe ? { name: 'SH Search Submitted', template: 'search', properties: { SearchQuery: safe, ResultsCount: raw.ResultsCount, URL: canonicalUrl } } : null;
    } catch { return null; }
  })();
  const pageViews = [product ? { name: 'Viewed Product', properties: product } : null, pageActivity].filter(Boolean);
  const pageVisible = (view) => {
    if (!view.template) return true;
    const element = document.querySelector(`main[data-template="${view.template}"]`);
    if (!element?.isConnected || !element.getClientRects().length) return false;
    for (let node = element; node; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    return true;
  };
  const viewPage = async (sdk, view) => {
    if (view.viewed || view.pending || identityPending || identityFailed || !permitted() || !pageVisible(view)) return;
    const generation = epoch;
    view.pending = true;
    try {
      const isIdentified = sdk.isIdentified;
      if (!permitted() || generation !== epoch) return;
      const known = await wait(isIdentified.call(sdk), generation);
      if (known !== true || generation !== epoch || !permitted() || identityPending || identityFailed || view.viewed || !pageVisible(view)) return;
      const track = sdk.track;
      if (!permitted() || generation !== epoch) return;
      const properties = view.name === 'Viewed Product' ? { ...view.properties, locale: locale() } : (view.event ||= { ...view.properties, schema_version: 1,
        $event_id: window.crypto.randomUUID(), occurred_at: new Date(Date.now()).toISOString(), locale: locale() });
      const accepted = await wait(track.call(sdk, view.name, properties), generation);
      if (accepted === true && generation === epoch && permitted(false)) {
        view.viewed = true;
        if (view.name === 'Viewed Product') window.SportsHubEmailContext?.observeProduct(properties);
        else window.SportsHubEmailContext?.observeFamily(properties);
      }
    } catch { /* Anonymous, failed and stale checks never produce a page activity event. */ }
    finally { if (generation === epoch) view.pending = false; }
  };
  const viewPages = (sdk) => { for (const view of pageViews) viewPage(sdk, view); };
  const bindContext = (sdk) => window.SportsHubEmailContext?.bindProvider({
    async publish(properties, descriptor) {
      if (!permitted() || identityPending || identityFailed) return false;
      const generation = epoch;
      try {
        const known = await wait(sdk.isIdentified.call(sdk), generation);
        if (known !== true || generation !== epoch || !permitted() || identityPending || identityFailed) return false;
        if (descriptor?.intentChanged) properties.sh_email_stage = 'pending';
        const accepted = await wait(sdk.identify.call(sdk, properties), generation);
        if (accepted === false || generation !== epoch || !permitted(false) || identityPending || identityFailed) return false;
        if (descriptor?.intentChanged) {
          const qaOnly = descriptor.environment !== 'production';
          const event = { schema_version: 1, kind: descriptor.kind, intent_key: descriptor.intent_key,
            revision: descriptor.revision, signal_at: descriptor.signal_at, occurred_at: descriptor.observed_at,
            locale: locale(), environment: descriptor.environment, qa_only: qaOnly, $event_id: descriptor.intent_key };
          const tracked = await wait(sdk.track.call(sdk, 'SH Email Context Updated', event), generation);
          if (tracked !== true || generation !== epoch || !permitted(false) || identityPending || identityFailed) return false;
        }
        return true;
      } catch { return false; }
    },
  });
  const providerFor = (sdk) => ({
    async identify(properties) {
      if (!permitted()) throw new Error('Tracking unavailable');
      invalidate();
      const generation = epoch;
      identityPending = true; identityFailed = false;
      try {
        const identify = sdk.identify;
        if (!permitted() || generation !== epoch) throw new Error('Tracking unavailable');
        const response = identify.call(sdk, properties);
        properties = null;
        const result = await wait(response, generation);
        if (result === false || generation !== epoch || !permitted(false)) throw new Error('Tracking unavailable');
        identityPending = false;
        window.SportsHubEmailContext?.refreshCart();
        viewPages(sdk);
        return result;
      } catch (error) {
        if (generation === epoch) { identityPending = false; identityFailed = true; }
        throw error;
      }
    },
    track(name, properties) {
      const track = sdk.track;
      if (!permitted() || identityPending || identityFailed) return Promise.resolve(false);
      const generation = epoch;
      const result = track.call(sdk, name, properties);
      if (name === 'SH Variant Selected') Promise.resolve(result).then((accepted) => {
        if (accepted === true && generation === epoch && permitted(false) && !identityPending && !identityFailed) window.SportsHubEmailContext?.observeVariant(properties);
      }).catch(() => {});
      return result;
    },
  });
  const initializeObject = () => {
    // Official public initializer: https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object
    if (window.klaviyo) return;
    window._klOnsite = window._klOnsite || [];
    window.klaviyo = new Proxy({}, { get(_target, method) {
      if (method === 'push') return (...args) => window._klOnsite.push(...args);
      return (...args) => {
        const callback = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;
        return new Promise((resolve) => window._klOnsite.push([method, ...args, (result) => { callback?.(result); resolve(result); }]));
      };
    } });
    manualObject = window.klaviyo;
  };
  const block = (state) => {
    optOut(true);
    clearTimeout(timer); timer = null;
    invalidate();
    window.SportsHubEmailContext?.bindProvider(null);
    script.dataset.state = state;
    if ((inserted || connected) && !reloading) { reloading = true; window.location.reload(); }
  };
  const privacyVersion = () => {
    try {
      for (const element of document.querySelectorAll('script[src]')) {
        const url = new URL(element.src, window.location.href);
        const version = url.pathname.match(/\/consent-tracking-api\/v(0\.[12])\/consent-tracking-api\.js$/)?.[1];
        if (version && url.protocol === 'https:' && (url.origin === window.location.origin || url.hostname === 'cdn.shopify.com')) return version;
      }
    } catch { /* Without a recognized official script, request the default version. */ }
    return '0.2';
  };
  const attempt = () => {
    clearTimeout(timer); timer = null;
    if (stopped || reloading) return;
    const consent = permission();
    if (consent !== 'allowed') {
      script.dataset.state = consent;
      if (consent === 'blocked') { block('blocked'); return; }
      if (inserted || featureFailed) { block('unavailable'); return; }
      if (!featureRequested) {
        try {
          if (typeof window.Shopify?.loadFeatures === 'function') {
            const generation = epoch;
            let retried = false;
            const load = (version) => {
              featurePending = true; featureRequested = true;
              script.dataset.privacyState = 'load-requested'; script.dataset.privacyVersion = version;
              try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version }], (error) => {
                featurePending = false;
                if (generation !== epoch || stopped || reloading) return;
                if (Array.isArray(error)) { script.dataset.privacyErrorKind = 'array'; script.dataset.privacyErrorCount = String(error.length); }
                const failed = Array.isArray(error) ? error.length > 0 : Boolean(error);
                if (failed && version === '0.2' && !retried && privacyMessage(error).trim() === 'consent-tracking-api@0.2 has already been loaded at version 0.1') {
                  retried = true; load('0.1'); return;
                }
                if (failed) { featureFailed = true; privacyError('error-load', error); block('unavailable'); return; }
                script.dataset.privacyState = 'loaded';
                attempt();
              }); } catch (error) { featurePending = false; featureFailed = true; privacyError('error-load', error); block('unavailable'); }
            };
            load(privacyVersion());
          }
        } catch (error) { featurePending = false; featureFailed = true; privacyError('error-load', error); block('unavailable'); return; }
      }
    } else if (!document.hidden) {
      try {
        const sdk = window.klaviyo;
        const adapter = window.SportsHubEmailEvents;
        const sdkReady = sdk && !Array.isArray(sdk) && (sdk !== manualObject || sdkLoaded) &&
          typeof sdk.track === 'function' && typeof sdk.identify === 'function' && typeof sdk.isIdentified === 'function';
        if (Date.now() <= deadline && sdkReady && typeof adapter?.setProvider === 'function') {
          if (!permitted()) { block('blocked'); return; }
          if (authenticatedIdentity(adapter) === 'unavailable') { script.dataset.state = 'unavailable'; return; }
          if (connected !== sdk && !identityPending) { optOut(false); adapter.setProvider(providerFor(sdk)); bindContext(sdk); connected = sdk; }
          script.dataset.state = 'ready';
          viewPages(sdk);
          return;
        }
        if (!inserted && !sdkReady && permitted()) {
          optOut(false);
          initializeObject();
          const member = authenticatedIdentity(adapter);
          if (member === 'unavailable') { script.dataset.state = 'unavailable'; return; }
          // Shopify manual-install pattern: queue public identify before the asynchronous SDK can run.
          if (member === 'queued') { adapter.setProvider(providerFor(window.klaviyo)); bindContext(window.klaviyo); connected = window.klaviyo; }
          const loader = document.createElement('script');
          loader.id = 'sh-klaviyo-sdk'; loader.async = true; loader.src = sdkUrl;
          const generation = epoch;
          loader.onload = () => {
            if (!permitted(false)) return;
            sdkLoaded = true; initializeObject(); start();
          };
          loader.onerror = () => { if (generation === epoch && !stopped && !reloading) script.dataset.state = 'unavailable'; };
          inserted = true;
          document.head.appendChild(loader);
        }
      } catch { script.dataset.state = 'unavailable'; }
      script.dataset.state = 'unavailable';
    } else { script.dataset.state = 'unavailable'; return; }
    if (Date.now() < deadline) timer = setTimeout(attempt, 500);
  };
  const start = () => { deadline = Date.now() + 15000; attempt(); };
  document.addEventListener('visitorConsentCollected', () => {
    if (permission() !== 'allowed') block(permission());
    else start();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { clearTimeout(timer); timer = null; }
    else start();
  });
  window.addEventListener('pagehide', () => { stopped = true; clearTimeout(timer); invalidate(); });
  window.addEventListener('pageshow', (event) => { if (event.persisted) { stopped = false; start(); } });
  start();
})();

